import { useState, useEffect } from "react";

import {
  Box,
  Grid,
  Typography,
  Button,
  Dialog,
  Avatar,
  useTheme,
} from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLeaf } from "@fortawesome/free-solid-svg-icons";

import { AnimatedLogo, Link, DefaultPaper } from "@aclymatepackages/atoms";

import { PlatformLayoutContextProvider } from "../../helpers/contexts/platformLayout";
import { useAccountData, signOut } from "../../helpers/firebase";
import { analyticsTrack } from "../../helpers/analytics";

const ShowExpiredFootprintSummary = () => {
  const { palette } = useTheme();

  const [{ employeeCount, name }, accountDataLoading] = useAccountData();

  const [trackEventSent, setTrackEventSent] = useState(false);

  useEffect(() => {
    if (!accountDataLoading && !trackEventSent) {
      analyticsTrack("Trial Expired", { name, employeeCount });
      setTrackEventSent(true);
    }
  }, [name, accountDataLoading, employeeCount, trackEventSent]);

  return accountDataLoading ? (
    <Box p={4} display="flex" alignItems="center" justifyContent="center">
      <AnimatedLogo />
    </Box>
  ) : (
    <Box
      p={2}
      display="flex"
      alignItems="center"
      justifyContent="center"
      style={{
        height: "100vh",
        backgroundColor: palette.backgroundGray.main,
        boxSizing: "border-box",
      }}
    >
      <Dialog open>
        <DefaultPaper>
          <Grid container direction="column" spacing={4} alignItems="center">
            <Grid item>
              <Avatar
                style={{
                  backgroundColor: palette.secondary.main,
                  height: 100,
                  width: 100,
                }}
              >
                <FontAwesomeIcon icon={faLeaf} size="2x" />
              </Avatar>
            </Grid>
            <Grid item>
              <Typography variant="h3" align="center">
                Your subscription to Aclymate has expired.
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="h6" align="center" color="textSecondary">
                The good news is that Aclymate makes it accessible to take
                action on climate.
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="h6" align="center" color="textSecondary">
                Reach out to our sales team to get started again.
              </Typography>
            </Grid>
            <Grid item>
              <Grid container spacing={2} justifyContent="center">
                <Grid item>
                  <Link href="https://calendly.com/tyler-aclymate/intro-meeting">
                    <Button variant="contained" color="primary">
                      Talk To Sales
                    </Button>
                  </Link>
                </Grid>
              </Grid>
              <Grid container justifyContent="center">
                <Grid item>
                  <Button
                    size="small"
                    color="inherit"
                    style={{ textDecoration: "underline" }}
                    onClick={() =>
                      signOut().then(() => {
                        return window.sessionStorage.clear();
                      })
                    }
                  >
                    logout
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DefaultPaper>
      </Dialog>
    </Box>
  );
};

const ExpiredAccountFootprintSummary = () => (
  <PlatformLayoutContextProvider>
    <ShowExpiredFootprintSummary />
  </PlatformLayoutContextProvider>
);
export default ExpiredAccountFootprintSummary;
